module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Discovery-Of-Witches-A-S1.a76906e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Discovery-Of-Witches-A-S1.jpg
// module id = 5tX5
// module chunks = 0